module.exports = __webpack_public_path__ + "img/section-7-d.63494a5.webp";